/// <reference types="fhir" />

import { Component, Input, OnInit } from "@angular/core";
import {
  TopicItem,
  Topic,
  DialogueInputType,
  IRelevantSupportActionModalNavParams
} from "../../../app/models/types";
import { OptionObject } from "@zitelab/ionic-fhir-questionnaires";
import { DiaprofilPatient } from "../../../app/models/diaprofil-patient";
import { RelevantSupportActionsModal } from "../../../modals/relevant-support-actions.modal/relevant-support-actions.modal";
import { ModalController } from "ionic-angular";
import { DiaprofilProTask } from "../../../app/models/diaprofil-pro-task";
import {
  EventLoggingService,
  LogEventId
} from "../../../app/services/event-logging.service";

@Component({
  selector: "dialogue-input-card",
  templateUrl: "./dialogue-input-card.html"
})
export class DialogueInputCard implements OnInit {
  @Input() inputType: DialogueInputType;
  @Input() inputHeader: string;
  @Input() inputTopic: Topic;
  @Input() inputItem: TopicItem;
  @Input() inputOtherItem: TopicItem;
  @Input() patient: DiaprofilPatient;
  @Input() task: DiaprofilProTask;
  answers: OptionObject[] = [];
  otherSpecified: string;
  constructor(
    private modalCtrl: ModalController,
    private eventLogging: EventLoggingService
  ) {
    // Empty block for now
  }

  ngOnInit() {
    this.answers = this.inputItem.answerInfo.optionObj as OptionObject[];
    console.log(this.answers);
    if (!Array.isArray(this.answers)) {
      this.answers = [this.answers];
    }
    if (
      this.inputItem !== undefined &&
      this.inputItem.answerInfo.rawAnswer.indexOf("OTHER") > -1
    ) {
      this.otherSpecified = this.inputOtherItem.answerInfo.rawAnswer;
      if (
        this.otherSpecified === null ||
        this.otherSpecified === undefined ||
        this.otherSpecified === ""
      ) {
        this.otherSpecified = "Andet (mangler beskrivelse)";
      }
    }
  }

  openRelevantSupportActionsModal(optionObject: OptionObject) {
    this.eventLogging.saveEvent({
      event_id: LogEventId.OPEN_SUPPORT_ACTION_MODAL,
      event_src_location: "DialogueInputCard",
      parent_task_uuid: this.task.task.id,
      qnr_response_uuid: this.task.response.id,
      patient_fhir_id: this.patient.fhirId,
      patient_full_name: this.patient.fullName,
      additional_info: {
        optionObject: optionObject.code,
        item: this.inputItem.config.name
      }
    });
    const data: IRelevantSupportActionModalNavParams = {
      supportFor: {
        proItems: [],
        patientWishes: this.inputType === "PATIENT_WISH" ? [optionObject] : [],
        consultationTopics:
          this.inputType === "CONSULTATION_TOPIC" ? [optionObject] : [],
        scoreIds: []
      },
      patient: this.patient,
      modalType: this.inputType,
      modalTitle: `"${optionObject.display}”`
    };
    const modal = this.modalCtrl.create(RelevantSupportActionsModal, data, {
      cssClass: "large-modal",
      enableBackdropDismiss: false
    });
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard.page/dialogue-input-card.component/dialogue-input-card.ts